import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getAccountAvatars, getClubList } from '../../store/selectors';
import '../../assets/stylesheets/Units/ClubAvatar.sass';

const ClubAvatar = ({ id, className, withoutRole }) => {
  const avatars = useSelector(getAccountAvatars);
  const styles = useMemo(() => {
    const avatar = avatars[id];
    if (!avatar) return {};
    if (!avatar.imagePath) return { backgroundColor: '#000000'};
    if (!avatar.frame) return { backgroundImage: `url(${avatar.imagePath})` };
    return {
      backgroundImage: `url(${avatar.imagePath})`,
      backgroundSize: 'initial',
      width: avatar.frame.w,
      height: avatar.frame.h,
      backgroundPosition: `-${avatar.frame.x}px -${avatar.frame.y}px`,
    };
  }, [avatars]);

  const clubs = useSelector(getClubList);
  const role = useMemo(() => {
    const club = clubs.find(c => c.clubId === id);
    if (!club) return 'player';
    return club.clubRole;
  }, [clubs]);

  const classes = ["club-avatar"];
  if (className) classes.push(className);
  if (!withoutRole) {
    if (role === 'owner')   classes.push('club-avatar--owner');
    if (role === 'agent')   classes.push('club-avatar--agent');
    if (role === 'manager') classes.push('club-avatar--manager');
  }

  return (
    <div className={classes.join(' ')}>
      <div className="club-avatar__image" style={styles} />
    </div>
  );
};

export default ClubAvatar;